<template>
    <v-card>
        <v-form v-model="valid" ref="createContactListForm" @submit="save" onSubmit="return false">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Create Contact list</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-layout>
                        <v-flex md6>

                            <v-text-field label="Name of Contact list"
                                          v-model="contactList.name"
                                          counter="100"
                                          ref="contactListName"
                                          :rules="serverValidation('name','Contact List Name')"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-alert dense outlined color="info">Click Add Contact or Add User Below to Add New Contacts or Existing Users to this List.  Users Listed Here Will be Contacted Based on Their Profile Phone Number</v-alert>
                    <v-banner outlined class="green text--black font-weight-bold">
                        Contacts
                        <template v-slot:actions>
                            <v-btn text v-on:click="addContact()">Add Contact</v-btn>
                        </template>
                    </v-banner>
                    <v-layout>
                        <v-flex md12>
                            <v-simple-table v-show="contactList.contacts && contactList.contacts.length > 0">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Contact Name</th>
                                            <th>Phone Number</th>
                                            <th>Remove</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(contact,index) in contactList.contacts">
                                            <td>
                                                <v-text-field placeholder="Contact Name" v-model="contact.name" required></v-text-field>
                                            </td>
                                            <td>
                                                <v-text-field v-model="contact.phoneNumber"
                                                              placeholder="Phone Number"
                                                              v-mask="'(###) - ### - ####'"
                                                              required></v-text-field>
                                            </td>
                                            <td>
                                                <v-btn @click="deleteContact(index)">Delete</v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-flex>
                    </v-layout>
                    <v-banner outlined class="green text--black font-weight-bold">
                        Users
                        <template v-slot:actions>
                            <v-btn text v-on:click="addUsers()">Add User(s)</v-btn>
                        </template>
                    </v-banner>
                    <v-layout flex>
                        <v-flex md12>
                            <v-simple-table
                                    item-key="id"
                                    v-show="contactList.users && contactList.users.length > 0">
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th>User Name</th>
                                        <th>Phone Number</th>
                                        <th>Remove</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(user,index) in contactList.users" v-bind:key="user.id">
                                            <td>
                                                {{user.name}}
                                            </td>
                                            <td>
                                                {{user.phoneNumber}}
                                            </td>
                                            <td>
                                                <v-btn @click="deleteUser(index)">Delete</v-btn>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn class="mx-2" outlined type="button" @click="cancel()" color="warning" :disabled="saveOverlay">Cancel</v-btn>
                <v-btn class="mx-2" outlined type="submit" color="success" :disabled="saveOverlay">Save</v-btn>
                <v-progress-circular
                        :width="3"
                        v-show="saveOverlay"
                        color="red"
                        indeterminate="">
                </v-progress-circular>
            </v-card-actions>
        </v-form>
        <!-- User Search Dialog -->
        <v-dialog :eager="true" v-model="searchUserDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="closeSearchUserDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Select Users</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <SearchUsers ref="userSearchDialog"
                                 :limit-to-organization="organizationId"
                                 @selected="selectUsers"
                                 @cancel="cancelSelectUsers"
                    ></SearchUsers>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-2" color="warning" outlined @click="closeSearchUserDialog()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <confirm-dialog ref="confirmDialog"></confirm-dialog>
    </v-card>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'
    import SearchUsers from "../../user/SearchUsers";
    import ConfirmDialog from "@/components/common/ConfirmDialog";

    export default {
        name:"CreateOrganizationContactList",
        mixins:[validationMixin],
        components: {SearchUsers, ConfirmDialog},
        data() {
            return {
                loadingOverlay:true,
                saveOverlay: false,
                valid: false,
                contactList : {
                    name:'',
                    contacts: [],
                    users : []
                },
                organizationId : null,
                searchUserDialog: false,
                componentKey : 0
            }
        },
        methods: {
            open(organizationId) {
                this.reset();
                this.organizationId = organizationId;
                this.loadingOverlay = false;
            },
            reset() {
                this.contactList = {contacts:[]};
                this.violations = [];
                this.organizationId = null;
                this.loadingOverlay = true;
            },
            validate() {
                let bad = false;
                if (this.contactList.contacts) {
                    this.contactList.contacts.forEach((c) => {
                        if ((!c.name || c.name == '') || (!c.phoneNumber || c.phoneNumber == '')) {
                            bad = true;
                        }
                    })
                }
                if (bad) {
                    return false;
                }
                return true;
            },
            save() {
                if (!this.validate()) {
                    this.$root.$emit('globalError','Please Specify Names and Phone Numbers For Each Contact');
                    return;
                }
                this.saveOverlay = true;
                this.contactList.organizationId = this.organizationId;
                api.contactList.post(this.contactList).then((data) => {
                    this.reset();
                    this.$emit('saved',data);
                    this.$root.$emit('globalMessage','Contact List Saved');
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.createContactListForm.validate();
                    }
                }).finally(() => {
                    this.saveOverlay = false;
                })
            },
            addContact() {
                if (!this.contactList.contacts) {
                    this.contactList.contacts = [];
                }
                this.contactList.contacts.push({});
            },
            deleteContact(index) {
                this.$refs.confirmDialog.open('Remove Contact','Are You Sure?').then((confirm) => {
                    if (confirm) {
                        this.contactList.contacts.splice(index, 1);
                    }
                });
            },
            deleteUser(index) {
                this.$refs.confirmDialog.open('Remove User', 'Are You Sure?').then((confirm) => {
                    if (confirm) {
                        this.contactList.users.splice(index, 1);
                    }
                });
            },
            addUsers() {
                this.searchUserDialog = true;
                this.$refs.userSearchDialog.open();
            },
            cancelSelectUsers() {
                this.searchUserDialog = false;
            },
            selectUsers(idMap) {
                if (!this.contactList.users) {
                    this.$set(this.contactList,'users',[]);
                }
                for (let newUserId in idMap) {
                    let newUser = idMap[newUserId];
                    let has = false;
                    for (let i=0;i<this.contactList.users.length;i++) {
                        if (this.contactList.users[i].id == newUser.id) {
                            has = true;
                        }
                    }

                    if (!has) {
                        this.contactList.users.push({
                            id : newUser.id,
                            name : newUser.firstName,
                            phoneNumber : newUser.phoneNumber
                        });
                    }

                }

                this.componentKey = this.componentKey+1;
                this.$nextTick(() => {
                    this.searchUserDialog = false;
                });
            },
            closeSearchUserDialog() {
                this.searchUserDialog = false;
            },
            cancel() {
                this.reset();
                this.$emit('cancelled');
            }
        }
    }

</script>